import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList, Link2, Coins, Sparkles, Leaf, Baby, Briefcase, Feather } from "lucide-react";
import PublicShell from "@/components/PublicShell";
import { usePageMeta } from "@/lib/seo";
import { cardCls, btnGold } from "@/lib/creators";

export const STEPS = [
  [ClipboardList, "Apply", "Tell us about you and your audience. It takes about three minutes."],
  [Link2, "Get your page", "Your own horoscope page at astralogico.com/c/yourname, plus ready-made story cards and captions."],
  [Coins, "Share and earn 40%", "Post your daily horoscope link. When followers buy a reading or Premium, you earn commission."],
];
export const ARCHETYPES = [
  [Sparkles, "Gen Z Mystic", "19–24", "Tarot, moon rituals and astrology memes for a young, curious audience."],
  [Leaf, "Wellness", "25–34", "Self-care, journaling and mindful routines guided by the sky."],
  [Baby, "Mum", "35–44", "Family life, kids' signs and a moment of calm in a busy day."],
  [Briefcase, "Career", "45–54", "Timing, ambition and big decisions with the planets in mind."],
  [Feather, "Wise Guide", "55+", "Experience, reflection and long-view astrology for a loyal following."],
];
export const TERMS = [
  "40% commission on every reading and Premium payment for your first 6 months, then 20%.",
  "30-day cookie: you're credited for purchases up to 30 days after someone taps your link.",
  "Monthly payouts straight to your bank through Stripe.",
  "You must label sponsored posts #ad, as required by the ASA (UK) and FTC (US).",
];

export default function CreatorsLanding() {
  usePageMeta("Astra Creator Program · Get Paid to Share Your Daily Horoscope", "/creators", "Join 20 founding creators sharing Astra's daily horoscope. Your own page on astralogico.com and 40% commission.");
  return (
    <PublicShell testId="creators-landing">
      <div className="px-6 pt-6 lg:max-w-5xl lg:mx-auto lg:px-10 fade-up">
        <p className="text-[11px] uppercase tracking-[0.35em] gold-text mb-3">Astra Creator Program</p>
        <h1 data-testid="creators-hero-title" className="text-4xl sm:text-5xl lg:text-6xl font-light leading-tight max-w-3xl">Get Paid to Share Your Daily Horoscope.</h1>
        <p className="text-2xl lg:text-3xl font-light gold-text mt-2">20 Founding Spots.</p>
        <p className="text-base lg:text-lg text-[#D6D0C5] mt-5 max-w-xl">Share horoscopes written from where the planets really are, on your own branded page, and earn on every reading your followers buy.</p>
        <Link to="/creators/apply" data-testid="creators-hero-apply" className={`${btnGold} inline-flex items-center gap-2 mt-8 text-lg px-8 py-3.5`}>Apply now <ArrowRight size={18} /></Link>

        <h2 className="text-lg text-starlight mt-16 mb-4">How it works</h2>
        <ol className="grid gap-3 lg:grid-cols-3" data-testid="creators-steps">
          {STEPS.map(([Icon, t, d], i) => (
            <li key={t} className={cardCls}>
              <span className="flex items-center gap-3 mb-2"><span className="w-8 h-8 rounded-full bg-[#D4AF37] text-[#04060B] flex items-center justify-center font-medium">{i + 1}</span><Icon size={18} className="gold-text" /></span>
              <p className="text-xl">{t}</p>
              <p className="text-sm text-[#A7B0C0] mt-1">{d}</p>
            </li>
          ))}
        </ol>

        <h2 className="text-lg text-starlight mt-14 mb-1">Who we look for</h2>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#A7B0C0] mb-4">Example archetypes</p>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-testid="creators-archetypes">
          {ARCHETYPES.map(([Icon, t, age, d]) => (
            <div key={t} className={`${cardCls} lg:p-4`}>
              <Icon size={20} className="gold-text" />
              <p className="text-lg mt-2">{t}</p>
              <p className="text-sm gold-text">{age}</p>
              <p className="text-sm text-[#A7B0C0] mt-2">{d}</p>
            </div>
          ))}
        </div>

        <h2 className="text-lg text-starlight mt-14 mb-4">Commission</h2>
        <ul className={`${cardCls} space-y-3`} data-testid="creators-commission">
          {TERMS.map((t) => <li key={t} className="flex gap-3 text-base text-[#D6D0C5]"><Coins size={16} className="gold-text shrink-0 mt-1" />{t}</li>)}
        </ul>

        <div className="mt-14 mb-6 text-center">
          <Link to="/creators/apply" data-testid="creators-bottom-apply" className={`${btnGold} inline-flex items-center gap-2 text-lg px-10 py-3.5`}>Apply for a founding spot <ArrowRight size={18} /></Link>
          <p className="text-sm text-[#A7B0C0] mt-4">Already a creator? <Link to="/creators/login" data-testid="creators-login-link" className="gold-text underline underline-offset-4">Sign in to your dashboard</Link></p>
        </div>
      </div>
    </PublicShell>
  );
}
